// Utility function to sort an array of objects by their 'name' property in ascending order
export function sortByName<T extends { name: string }>(data: T[]): T[] {
    return data.slice().sort((a, b) => a.name.localeCompare(b.name));
}

// Utility function to sort an array of objects by their 'number' property in ascending order
export function sortByNumber<T extends { number: number }>(data: T[]): T[] {
    return data.slice().sort((a, b) => a.number - b.number);
}
